<template>
  <!-- ratio-5-4-card -->
  <!-- <rollover-card v-bind:spanclass="span_computed" ratioclass="ratio-5-4-card"> -->
    
  <div class="relative span-6-lg offset-1-lg span-6-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs debug ratio-flip-card testing-outer">

    <!-- <div class="slide-outer">
      <div class="slide-content debug extra-max-width"> -->
      
      <div class="testing">
        <slot></slot>
      </div>

        <!-- <div class="float-right">
          <nav-button type="share">share</nav-button>
        </div> -->

      <!-- </div>
    </div> -->

  </div>

  <!-- </rollover-card> -->
</template>

<script>
  import rollover_card from '../molecules/rollover_card'
  import nav_button from '../molecules/button'

  export default {
    props: ['bump'],
    components: {
      'rollover-card': rollover_card,
      'nav-button': nav_button
    },
    computed: {
      span_computed () {
        if (this.bump.indexOf('down') !== -1) {
          return "span-6-lg offset-2-lg span-6-md offset-2-md span-14-sm offset-1-sm span-14-xs offset-1-xs max-100 " + this.bump
        }
        return "span-6-lg offset-1-lg span-6-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs max-100 " + this.bump
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  // .testing-outer {
  //   max-height: calc(100vh - 98px - 96px - 96px);
  // }

  // .testing {
  //   position: relative;
  //   // max-height: calc(100% - 98px - 96px); // 98 computed height of header paragraph, 96 margin
  //   max-height: 100%;
  //   overflow: auto;
  // }

  .bump-up {
    transform: translateY(-18px);
  }

  .bump-down {
    transform: translateY(18px);
  }

  .bump-up, .bump-down {
    @media screen and (max-width: $sm-max) {
      transform: none;
      margin-bottom: 36px;
    }
  }

  .slide-outer {
    position: relative;
    display: flex;
    // overflow: hidden;
    // max-height: 100%;
  }

  .float-right {
    float: right;
  }

  // todo: import .slide-content class, reused here and on overflow_image.vue

  .slide-content {
    position: relative;
    margin: auto;
    
    max-width: calc((100% * 6/8) - 48px); // 48px to account for margin
    &.extra-max-width {
      @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
        max-width: calc(100% - 24px - 24px);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// share_card.vue?6c68c93a